import { createFileRoute } from "@tanstack/react-router";
import { GetStarted } from "../../../features/onboarding/components/get-started";

export const Route = createFileRoute("/w/$slug/get-started")({ component: GetStarted });
